export default __webpack_public_path__ + "static/simple-area-50bcf3105059d0bf5918807fb5788554.png";